﻿export class request_register {
    public name: string = "";
    public agency_name: string = "";
    public agency_phone_number: string = "";
    public agency_address_line_1: string = "";
    public agency_address_line_2: string = "";
    public agency_email: string = "";
    public iata: string = "";
    public abn: string = "";
}